// chart+table סמוכים (pairBlocks): דסקטופ — זה לצד זה; מובייל (<768px) — toggle, טבלה כברירת מחדל.
import { BlockHead } from './Expand.tsx';
import { useRef, useState } from 'react';
import type { ChartBlock as ChartBlockT, TableBlock as TableBlockT } from '@aibify/core';
import { ChartView, useChartPng } from './ChartBlock.tsx';
import { TableBlock, useXlsxExport, type TableView } from './TableBlock.tsx';
import { S } from './strings.ts';

export function PairView({ chart, table }: { chart: ChartBlockT; table: TableBlockT }) {
  const [view, setView] = useState<'table' | 'chart'>('table');
  const host = useRef<HTMLElement>(null);
  const png = useChartPng(chart, host);
  const tableView = useRef<TableView | null>(null);
  const xlsx = useXlsxExport(table, tableView);
  return (
    <section ref={host} className="ab-block ab-pair" data-block-type="pair" data-view={view} data-block-id={`${chart.id}+${table.id}`}>
      <BlockHead titleHe={table.titleHe ?? chart.titleHe}>
        <div className="ab-toggle" role="group" aria-label={`${S.viewTable}/${S.viewChart}`}>
          <button type="button" aria-pressed={view === 'table'} onClick={() => setView('table')}>
            {S.viewTable}
          </button>
          <button type="button" aria-pressed={view === 'chart'} onClick={() => setView('chart')}>
            {S.viewChart}
          </button>
        </div>
        <button type="button" className="ab-btn ab-btn-ghost" onClick={xlsx}>
          {S.exportXlsx}
        </button>
        <button type="button" className="ab-btn ab-btn-ghost ab-desktop-only" onClick={png}>
          {S.exportPng}
        </button>
      </BlockHead>
      <div className="ab-pair-body">
        <div className="ab-pair-table">
          <TableBlock block={table} bare viewRef={tableView} />
        </div>
        <div className="ab-pair-chart">
          <ChartView block={chart} />
        </div>
      </div>
    </section>
  );
}
